/**
 *
 * AllCourses
 *
 */

import { mapGetters } from 'vuex';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';
import { LOADING_MESSAGE } from './AllCourses.constants';

export default {
  name: 'AllCourses',

  components: {
    WayFindBar,
    Footer,
    Aside,
    //TabBar,
    Spinner,
    PzButton,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapGetters({
      MainCourses: 'AllCourses/MainCourses',
      MiniCourses: 'AllCourses/MiniCourses',
      immLoading: 'immLoading',
      userInfo: 'userInfo',
    }),
    hasLogin() {
      return !this.userInfo.unLogin;
    },
  },

  created() {
    this.$store.dispatch('AllCourses/getAllCourses');
  },

  methods: {
    goTo(path) {
      this.$router.push(path);
    },
  },
};
